import { useMutation } from '@apollo/client'
import {
  BulkUpdateProcessesStepStepsInput,
  BulkUpdateStepsDocument,
  GetProcessDetailDocument,
} from 'generated/resources/graphql'

export type BulkUpdateSteps = BulkUpdateProcessesStepStepsInput

export const useBulkUpdateSteps = () => {
  const [executeMutation, { loading }] = useMutation(BulkUpdateStepsDocument)

  const bulkUpdateSteps = async (steps: BulkUpdateSteps[], processId: number) => {
    const { data, errors } = await executeMutation({
      variables: {
        steps,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.bulkUpdateProcessesStep?.errors.length) {
      throw (
        'Could not update step: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.bulkUpdateProcessesStep?.errors || []),
        ])
      )
    }
  }

  return {
    bulkUpdateSteps,
    loading,
  }
}
